/**
 * Valores controlados do domínio comercial.
 *
 * Espelham os enums do Prisma, mas vivem aqui porque o frontend precisa deles
 * e não pode depender do pacote de banco. Qualquer alteração precisa ser feita
 * nos dois lugares, junto com a migração correspondente.
 */
export const PAPEIS_USUARIA = ['ADMINISTRADORA', 'COMERCIAL'];
export const TIPOS_CONTATO = ['PESSOA', 'EMPRESA'];
/**
 * As origens de que o código depende, e que por isso o cadastro não deixa
 * excluir nem desativar — só renomear.
 *
 * "Reducee" é a casa: prospecção própria, base antiga, o que não veio de fora,
 * e é a origem de quem entra sem outra declarada. "Meta Ads" é a que a
 * ingestão da Meta marca sozinha. "Parceiro" é a que exige dizer qual parceiro
 * trouxe a venda.
 */
export const ORIGENS_TRAVADAS = ['REDUCEE', 'PARCEIRO', 'META_ADS'];
export function origemTravada(codigo) {
    return ORIGENS_TRAVADAS.includes(codigo);
}
/** Maiúsculas, dígitos e sublinhado: o formato dos códigos que o cadastro gera. */
export const FORMATO_CODIGO_ORIGEM = /^[A-Z0-9_]{1,60}$/;
/**
 * Teto das observações do Lead e do Contato, em caracteres.
 *
 * O campo existe para a Comercial colar o que sabe — uma conversa de WhatsApp
 * inteira, as anotações de uma ligação —, e isso passa fácil dos 2.000 que o
 * cadastro aceitava. O banco guarda texto sem limite; o teto está aqui para a
 * api recusar o absurdo, e para a tela dizer o número antes de recusar. Um
 * número só para os dois: a Comercial não tem por que descobrir que o limite
 * muda conforme a tela.
 */
export const TETO_DAS_OBSERVACOES = 10_000;
/**
 * Estado de um Anúncio da Meta, já traduzido para o vocabulário da operação.
 *
 * Nasce do `effective_status`, e nunca do `status`: medido nos 114 anúncios da
 * conta em 17/09/2026, 27 diziam `status: ACTIVE` e apenas 2 estavam mesmo no
 * ar. O filtro da parede abre em "No ar" — usar o campo errado mentiria 25
 * vezes logo na abertura.
 *
 * Os quatro motivos de estar fora do ar são valores separados, e não um
 * "pausado" só, porque a Administradora precisa saber onde mexer: pausar o
 * anúncio, a Campanha de anúncios e o Conjunto de anúncios são três telas
 * diferentes no Gerenciador.
 *
 * `DESCONHECIDO` é o default explícito. A Meta tem mais valores do que os cinco
 * que apareceram aqui, e mapear o que não se conhece para `PAUSADO` diria
 * "alguém desligou" sobre um anúncio que pode estar no ar.
 */
export const ESTADOS_ANUNCIO = [
    'NO_AR',
    'PAUSADO',
    'CAMPANHA_PAUSADA',
    'CONJUNTO_PAUSADO',
    'REPROVADO',
    'COM_PROBLEMA',
    'EM_ANALISE',
    'ARQUIVADO',
    'DESCONHECIDO',
];
/**
 * Tipos de contrato que uma venda nova pode ter.
 *
 * Individual e Adesão eram um valor só — `INDIVIDUAL_ADESAO`, escrito na tela
 * como "Individual/Adesão". São contratações diferentes: a individual é
 * contratada direto da operadora pela pessoa, e a por adesão passa por
 * entidade de classe, com regra de reajuste e de elegibilidade próprias.
 * Juntas, o número de uma não podia ser lido sem o da outra.
 */
export const TIPOS_CONTRATO = ['PME', 'INDIVIDUAL', 'ADESAO'];
/**
 * O valor antigo, que ninguém escolhe mais e que o banco ainda guarda.
 *
 * As vendas cadastradas antes da separação não foram convertidas: converter
 * seria escolher por elas entre individual e adesão sem ter como saber, e três
 * delas já viraram Contrato. Elas continuam legíveis, marcadas como a revisar,
 * e cada uma é corrigida quando alguém abrir a ficha.
 */
export const TIPOS_CONTRATO_LEGADOS = ['INDIVIDUAL_ADESAO'];
export const TIPOS_CONTRATO_GRAVADOS = [...TIPOS_CONTRATO, ...TIPOS_CONTRATO_LEGADOS];
export const ACOMODACOES = ['ENFERMARIA', 'APARTAMENTO', 'NAO_SE_APLICA'];
export const MODALIDADES = [
    'COM_COPARTICIPACAO',
    'SEM_COPARTICIPACAO',
    'NAO_SE_APLICA',
];
export const ETAPAS_FUNIL = [
    'LEAD',
    'QUALIFICADO',
    'REUNIAO',
    'PROPOSTA',
    'NEGOCIACAO',
    'FECHADO',
    'PERDIDO',
    'RECICLAGEM',
];
export const SCORES = ['BRONZE', 'PRATA', 'OURO', 'DIAMANTE'];
export const MOTIVOS_ENCERRAMENTO = [
    'SEM_RESPOSTA',
    'PRECO',
    'SEM_INTERESSE',
    'JA_POSSUI_CORRETOR',
    'FORA_DO_PERFIL',
    'DOCUMENTACAO',
    'REDE_INSUFICIENTE',
    'CARENCIA',
    'PRODUTO_INDISPONIVEL',
    'MOMENTO_INADEQUADO',
    'CADENCIA_CONCLUIDA_SEM_RESPOSTA',
    'OUTRO',
];
export const NIVEIS_ENGAJAMENTO = ['BAIXO', 'MEDIO', 'ALTO'];
/** Prazo declarado para contratar. Entra na ordenação da fila de atendimento. */
export const NIVEIS_URGENCIA = ['IMEDIATO', 'ATE_7_DIAS', 'ATE_30_DIAS', 'ACIMA_30_DIAS'];
export const CANAIS_CONTATO = [
    'LIGACAO',
    'WHATSAPP',
    'EMAIL',
    'SOCIAL_POINT',
    'OUTRO',
];
export const SENTIDOS_INTERACAO = ['SAIDA', 'ENTRADA'];
export const STATUS_CADENCIA = ['ATIVA', 'PAUSADA', 'CONCLUIDA', 'CANCELADA'];
export const MOTIVOS_PAUSA_CADENCIA = [
    'RESPOSTA_DO_CONTATO',
    'NAO_CONTATAR',
    'MUDANCA_DE_ETAPA',
    'MANUAL',
];
export const STATUS_CADENCIA_ACAO = ['PENDENTE', 'EXECUTADA', 'PULADA', 'CANCELADA'];
export const PRIORIDADES_TAREFA = ['BAIXA', 'MEDIA', 'ALTA', 'URGENTE'];
export const STATUS_TAREFA = ['A_FAZER', 'EM_ANDAMENTO', 'CONCLUIDA'];
export const ORIGENS_TAREFA = [
    'MANUAL',
    'CADENCIA',
    'REATIVACAO',
    'PROXIMO_PASSO',
    'IMPORTACAO',
    'META_ADS',
];
export const STATUS_IMPORTACAO = ['PREVIA', 'CONFIRMADA', 'DESCARTADA'];
export const STATUS_LINHA_IMPORTACAO = [
    'VALIDA',
    'ERRO',
    'DUPLICADA',
    'IMPORTADA',
    'IGNORADA',
];
export const TIPOS_IMPORTACAO = ['LEADS', 'CARTEIRA'];
/**
 * Parâmetros do hash de senha (Argon2id). Não são segredo: o hash gerado já os
 * carrega, o que permite verificar senhas antigas depois de um ajuste.
 */
export const PARAMETROS_ARGON2 = {
    memoryCost: 19_456,
    timeCost: 2,
    parallelism: 1,
};
// ------------------------------------------------------- Pos-venda (Fase 2)
export const STATUS_IMPLANTACAO = [
    'AGUARDANDO_DOCUMENTOS',
    'PROTOCOLADA',
    'AGUARDANDO_PAGAMENTO',
    'VIGENCIA_ATIVA',
    'CANCELADA',
];
export const STATUS_PARCELA = ['PENDENTE', 'PAGA', 'PAGA_COM_ATRASO', 'ISENTA'];
export const TIPOS_BENEFICIARIO = ['TITULAR', 'DEPENDENTE'];
/**
 * Graus de parentesco que a operadora aceita numa inclusão de dependente.
 *
 * Lista fechada porque é a operadora quem decide o que vale: "esposa",
 * "marido" e "companheira" escritos à mão viram três vínculos diferentes no
 * nosso banco e um só no formulário dela. A relação é a que as tabelas de
 * dependentes de plano de saúde reconhecem — quem não está aqui não é
 * dependente elegível, é outra apólice.
 */
export const GRAUS_DE_PARENTESCO = [
    'CONJUGE',
    'COMPANHEIRO',
    'FILHO',
    'ENTEADO',
    'TUTELADO',
    'PAI_MAE',
    'IRMAO',
    'NETO',
    'SOGRO',
];
export const TIPOS_MOVIMENTACAO = [
    'INCLUSAO',
    'EXCLUSAO',
    'TROCA_DE_PLANO',
    'ALTERACAO_CADASTRAL',
    'SEGUNDA_VIA',
    'CANCELAMENTO',
    'OUTRO',
];
export const STATUS_MOVIMENTACAO = [
    'ABERTA',
    'EM_ANDAMENTO',
    'AGUARDANDO_CLIENTE',
    'AGUARDANDO_OPERADORA',
    'CONCLUIDA',
    'CANCELADA',
];
export const CATEGORIAS_DOCUMENTO = [
    'CLIENTE',
    'CONTRATO',
    'MOVIMENTACAO',
    'IMPLANTACAO',
];
export const STATUS_RENOVACAO = [
    'PLANEJADA',
    'CONTATO_INICIADO',
    'EM_NEGOCIACAO',
    'PROPOSTA_ENVIADA',
    'RENOVADA',
    'PERDIDA',
];
export const STATUS_REVISAO = [
    'PENDENTE',
    'EM_ANALISE',
    'OPORTUNIDADE_ENCONTRADA',
    'SEM_MELHORIA',
    'CONCLUIDA',
];
// ------------------------------------ Comissoes, metas e canais (Fase 3)
export const CANAIS_LEMBRETE = ['EMAIL', 'WHATSAPP', 'MANUAL'];
export const CANAIS_COMISSAO = ['DIRETO_OPERADORA', 'LUHE', 'PLATAFORMA_VIDA'];
export const TIPOS_REGRA_COMISSAO = ['PARCELADA_COM_VITALICIO', 'PARCELA_UNICA'];
export const STATUS_COMISSAO = ['PREVISTA', 'RECEBIDA'];
export const STATUS_PARCEIRO = ['ATIVO', 'INATIVO'];
//# sourceMappingURL=enums.js.map